<template>
    <app-tab :tabs="tabsHorizontal" type="horizontal" /> 
</template>

<script>
import CoreLibrary from "../../../../../../../core/helpers/CoreLibrary.js";

export default {
  name: "Tabs",
  extends: CoreLibrary,
  props: {
    id: Number,
    back: Function,
  },
  data() {
    return {
      modalId: "my_task_modal",
      icon: "settings",
      isAddEditModalActive: false,
      tabsHorizontal: [
        {
          icon: "info",
          name: "Edit Task",
          component: "job-site-task-update",
          permission: "",
          props: { id: this.id, back: this.back},
        },
        {
          icon: "link",
          name: "Forms",
          component: "task-form-mainstep",
          permission: "",
          props: { id: this.id },
        },
      ],
    };
  },
};
</script>
